import React from 'react'
import { useLocation } from 'react-router-dom'

import CreateSiteInfo from '../../../../components/CreateSiteInfo'
import ContextMenu from '../../../../components/ContextMenu'

export default function () {
  const query = new URLSearchParams(useLocation().search)
  const siteId = query.get('siteId')

  return (
    <div className='container'>
      <ContextMenu
              renderTitle={() => (
                <h1 className="title">Add new site information</h1>
              )}
            ></ContextMenu>
      <CreateSiteInfo siteId={siteId} />
    </div>
  )
}
